<template>
    <div class="appoint-cont">
        <el-form label-position="right" :rules="rules" label-width="110px" ref="appointForm" :model="appointData">
            <el-form-item label="预约配送时间" :required="true">
                <div class="row-item">
                    <el-form-item prop="appointTime" >
                        <el-date-picker v-model="appointData.appointTime" class="appoint-date"
                            value-format="yyyy-MM-dd" placeholder="预约配送日期" type="date"
                            :picker-options="pickerOptions" :clearable="false" @change="()=>{appointData.delieveryTimeSlot=''}"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="delieveryTimeSlot" class="row-item-ml">
                        <el-select v-model="appointData.delieveryTimeSlot" placeholder="预约配送时间">
                            <el-option v-for="item in timeSlotOptions" :key="item.key" :value="item.value" :label="item.label"
                            :disabled="delieveryTimeSlotDisabled(item)"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="text" v-model="appointData.remark" clearable />
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import api from '../../../../../api/netTaskManage2c.js';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    props: {
        rowData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        saveFlag: {
            type: Boolean,
            default: () => {
                return true;
            }
        }
    },
    data() {
        return {
            appointReasonOptions: [],
            appointData: {
                factInstallType: '',
                appointTime: '',
                delieveryTimeSlot: '',
                installStartTime: '',
                installTimeSlot: '',
                appointReason: '',
                secendAppointReason: '',
                exceptionType: '',
                remark: '',
                revisiter: '',
                revisiterMobile: ''
            },
            rules: {
                appointTime: [
                    { required: true, message: '请选择配送日期', trigger: 'change' }
                ],
                delieveryTimeSlot: [
                    { required: true, message: '请选择配送时间', trigger: 'change' }
                ]
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                }
            },
            appointReasons: [],
            timeSlotOptions: [
                { value: '06:00:00-08:00:00', label: '06:00-08:00' },
                { value: '08:00:00-10:00:00', label: '08:00-10:00' },
                { value: '10:00:00-12:00:00', label: '10:00-12:00' },
                { value: '12:00:00-14:00:00', label: '12:00-14:00' },
                { value: '14:00:00-16:00:00', label: '14:00-16:00' },
                { value: '16:00:00-18:00:00', label: '16:00-18:00' },
                { value: '18:00:00-20:00:00', label: '18:00-20:00' },
                { value: '20:00:00-22:00:00', label: '20:00-22:00' }
            ],
            currentDate: dayjs().format('YYYY-MM-DD')
        };
    },
    computed: {
        delieveryTimeSlotDisabled() {
            return function(item) {
                const appointTime = this.appointData.appointTime;
                if (appointTime && dayjs(appointTime).format('YYYY-MM-DD') === this.currentDate) {
                    return item.label && item.label.split('-')[1].split(':')[0] <= dayjs().hour();
                }
            };
        },
        timeSlotOptionsDisabled() {
            return function(item) {
                const installStartTime = this.appointData.installStartTime;
                if (installStartTime && dayjs(installStartTime).format('YYYY-MM-DD') === this.currentDate) {
                    return item.label && item.label.split('-')[1].split(':')[0] <= dayjs().hour();
                }
            };
        }
    },
    mounted() {
        this.getTimeSlot();
    },
    methods: {
        async getTimeSlot() {
            // 获取时间选项
            const dictData = await dictWithUrl('NET_APPOINT_TIME_SLOT');
            const timeSlot = dictData.data.NET_APPOINT_TIME_SLOT || {};
            const timeSlotOptionsArrVal = Object.entries(timeSlot).sort();
            if (timeSlotOptionsArrVal && timeSlotOptionsArrVal.length) {
                this.timeSlotOptions = [];
                timeSlotOptionsArrVal.forEach(item => {
                    this.timeSlotOptions.push({
                        value: item[0],
                        label: item[1]
                    });
                });
            }
        },
        checkSave(selectedData) {
            if (!this.saveFlag) return this.$message.warning('此客户订单未签收完毕，无法进行预约');
            this.$refs.appointForm.validate((valid) => {
                if (valid) {
                    const params = selectedData.map(item => {
                        return {
                            deliveryStartTime: this.appointData.appointTime + ' ' + this.appointData.delieveryTimeSlot.split('-')[0],
                            deliveryEndTime: this.appointData.appointTime + ' ' + this.appointData.delieveryTimeSlot.split('-')[1],
                            orderNo: item.orderNo,
                            waybillNo: item.waybillNo,
                            appointRemark: this.appointData.remark || '',
                            factInstallType: 'DELIVERYONLY',
                            factInstallTypeName: '配送'
                        };
                    });
                    api.networkAppointment(params).then(res => {
                        this.$emit('saveResult', res && +res.code === 0);
                    }).catch(() => {});
                }
            });
        }
    }
};
</script>
<style lang="less">
.appoint-cont {
    .row-item {
        display: flex;
    }
    .appoint-reason {
        width: 100%;
    }
    .row-item-ml {
        margin-left: 10px;
    }
    .appoint-date {
        width: 100%;
    }
}
</style>